export default __webpack_public_path__ + "static/media/diet-type-mediterranian.6b433aae.jpg";